import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

import { Grid } from '@mui/material';

interface StatCardsProps {
    items: StatCardProps[];
}

interface StatCardProps {
    label: string;
    value: string | number;
}

const StatCards = (props: StatCardsProps) => {
    const { items = [] } = props;

    return (
        <Grid
            container
            spacing={2}
            sx={{
                justifyContent: 'space-between',
            }}
        >
            {items.map((i, index) => (
                <Grid key={index} style={{ flexGrow: 1 }}>
                    <Paper>
                        <Box sx={{ p: 3 }}>
                            <Typography
                                variant="caption"
                                sx={{
                                    color: 'text.secondary',
                                    display: 'block',
                                    fontWeight: 'fontWeightBold',
                                    mb: 0.5,
                                }}
                            >
                                {i.label}
                            </Typography>
                            <Typography variant="body1">{i.value}</Typography>
                        </Box>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
};

export default StatCards;
